import { ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { ExpoBoothFilterForm } from '../expo-booth-filter-form/expo-booth-filter-form';
import { ParticiateFilterFormValues } from '../transaction-filter-form/type';
import { useLocation } from 'react-router-dom';

type ParticipateTopBarProps = {
  getInitialFilterValues: ParticiateFilterFormValues;
  handleFilter: (values: ParticiateFilterFormValues) => void;
};

export const ExpoBoothTopBar = ({
  getInitialFilterValues,
  handleFilter,
}: ParticipateTopBarProps) => {
  useState<CompanyType>();
  const location = useLocation();
  const formId = 'expo-list-filters-form';
  
  return (

    <>
      <ContentTopBar
        title={location.pathname=='/transactions/expo-booth-list' ?'Expo Booth list' : 'Tickets List' }

      />

      <ContentFilters formId={formId}>
        <ExpoBoothFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
